import React, { useMemo } from 'react'
import { Alert } from 'antd'
import { useAuthContext } from '../../../../context/auth'
import { useExpertProfilesContext } from '../../../../context/expertProfile'
import { TExpertPage } from '../../../../context/types'

import './index.less'
import { useBrandContext } from '../../../../context/brand'
import { useChannelContext } from '../../../../context/channel'

const FillDataAlert = () => {
	const { auth } = useAuthContext()
	const { expertProfiles } = useExpertProfilesContext()
	const { brand } = useBrandContext()
	const { channel } = useChannelContext()
	const profile = expertProfiles.profiles[0]

	const isEmptyExpertPage = !profile?.pages.some(
		(page: TExpertPage) => !page.title || !page.body || !page.keywords?.length
	)
	const expertHaveToSetPayRate =
		brand.currentBrand?.experts_can_set_rates &&
		(channel?.channels || []).reduce(
			(acc, { integration_config, is_expert }) =>
				acc || (is_expert && integration_config?.experts_can_set_rates !== false),
			false
		) &&
		!expertProfiles.profiles[0]?.pay_rate

	const message: string = useMemo(() => {
		const headerMessage = 'In order to show up on search results and have users book calls with you, you must have:'
		const messages: string[] = []
		if (!auth?.user?.profile_pic_url) messages.push('profile picture')
		if (profile?.pages?.every((page) => !page.bio)) messages.push('bio')
		if (!profile?.user?.expertInfo?.cronofy_filled) messages.push('availability')
		if (expertHaveToSetPayRate) messages.push('pay rate')
		if (!isEmptyExpertPage) {
			messages.push(`provide information about expert details`)
		}

		return messages.length ? `${headerMessage} ${messages.join(', ')}` : null
	}, [auth?.user?.profile_pic_url, profile?.pages, profile?.user?.expertInfo?.cronofy_filled, isEmptyExpertPage])

	return (
		auth?.user?.isExpert &&
		!!message &&
		!expertProfiles.loading && (
			<Alert type="warning" className="fill-data_alert" showIcon message={message} style={{ width: '100%' }} />
		)
	)
}

export default FillDataAlert
